<section class="intro-section" id="program">
  <div class="content">
    <p class="title">Conviértete en Ingeniero de Software Comercial</p>
    <div class="description" #animation>
      <p>
        El objetivo del programa es formar profesionales que participen
        activamente en la aceleración digital y transformación de industrias,
        generando productos y servicios de software de calidad.
      </p>
      <p>
        Esta profesión es la más demandada a nivel global, y día a día se buscan
        ingenieros que puedan sumarse a diversos proyectos.
      </p>
      <p>
        Buscamos fomentar la creatividad a través del intercambio cultural que
        se desarrolla trabajando en equipos distribuidos por el mundo.
      </p>
      <p>Siendo Ingeniero de Software Comercial accederás a:</p>
      <p class="check-points">
        <img src="../../../assets/icons/check-icon.svg" />
        <span>Trabajar para un mundo sin fronteras</span>
      </p>
      <p class="check-points">
        <img src="../../../assets/icons/check-icon.svg" />
        <span>Lo puedes hacer desde la comodidad de tu casa</span>
      </p>
      <p class="check-points">
        <img src="../../../assets/icons/check-icon.svg" />
        <span>Salario competitivo en el sector</span>
      </p>
    </div>
  </div>
</section>
